









































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import * as Datepicker from "vuejs-datepicker";

@Component({ components: { datepicker: Datepicker.default } })
export default class CourseAdminView extends Vue {
  // existing courses
  courses: any[] = [];
  selected = { value: "" };

  // create new course
  newCourseName: any = { value: null };
  newCourseStartDate: any = { value: null };
  newCourseEndDate: any = { value: null };
  newCourseUrl: any = { value: null };

  constructor() {
    super();
    this.$axios.get("courses").then((req) => {
      const courseData = req.data;
      if (courseData instanceof Array) {
        for (let i = 0; i < courseData.length; i++) {
          this.courses.push(courseData[i]);
        }
      } else {
        this.courses.push(courseData);
      }

      if (localStorage.getItem("selectedCourse")) {
        this.selected.value = localStorage.getItem("selectedCourse") as string;
      } else {
        if (this.courses.length) {
          this.selected.value = this.courses[this.courses.length - 1][
            "id"
          ].toString();
        }
      }
    });
  }

  @Watch("selected.value")
  saveSelectedCourse(value: string, oldValue: string) {
    localStorage.setItem("selectedCourse", value);
  }

  toCourseView(id: string) {
    this.$router.push({
      name: "tutorials.admin.course",
      params: {
        id: id,
      },
    });
  }

  saveNewCourse(startDate: any, endDate: any, name: any, url: any) {
    if (startDate && endDate && name && this.noDuplicatedName(name)) {
      if (startDate instanceof Date && endDate instanceof Date) {
        if (
          (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24) >=
          5
        ) {
          const params = {
            /* eslint-disable @typescript-eslint/camelcase */
            start_date: startDate.toISOString().slice(0, 10),
            end_date: endDate.toISOString().slice(0, 10),
            gitlab_url: url,
            /* eslint-enable @typescript-eslint/camelcase */
            name: name,
          };
          this.$axios.post("courses/", params).then((req) => {
            this.newCourseName.value = "";
            this.newCourseStartDate.value = "";
            this.newCourseEndDate.value = "";
            this.newCourseUrl.value = "";
            this.$axios.get("courses").then((req) => {
              const courseData = req.data;
              this.courses = [];
              if (courseData instanceof Array) {
                for (let i = 0; i < courseData.length; i++) {
                  this.courses.push(courseData[i]);
                }
              } else {
                this.courses.push(courseData);
              }
            });
          });
        } else {
          alert(this.$t("coursesAdmin.alertDate"));
        }
      }
    } else {
      alert(this.$t("coursesAdmin.alertInput"));
    }
  }

  noDuplicatedName(name: string) {
    const courseName: string[] = this.courses.flatMap((c) => c["name"]);
    return courseName.indexOf(name) < 0;
  }

  deleteCourse(id: string, index: number) {
    if (confirm(this.$t("coursesAdmin.confirm") + " " + id + "?")) {
      this.$axios.delete("courses/" + id).then((req) => {
        this.courses.splice(index, 1);
        if (this.selected.value == id) {
          if (this.courses.length) {
            this.selected.value = this.courses[this.courses.length - 1]["id"];
          } else {
            this.selected.value = "";
          }
        }
        alert(this.$t("coursesAdmin.alert"));
      });
    }
  }
}
